import { Constructor } from './types';
import { getDef, isSchema } from './utils';

export function create<T, P = T>(schema: Constructor<T>, data: Partial<P> = {}): T {
	if (!isSchema(schema)) {
		throw new Error(`${schema.name} is not a schema`);
	}

	const def = getDef(schema);

	const assigns: any = {};

	for (const attr of def.attrs()) {
		const value = (data as any)[attr.name];

		if (attr.isField() && value !== undefined) {
			assigns[attr.name] = value;
		}
	}

	const instance = new schema();

	Object.assign(instance as any, assigns);

	return instance;
}
